module.exports = {
  PUSH_VAPID_PUBLIC_KEY:
    "BEfADsRg2K4857inkk-B_zw01GLPzz23e5XBqbortvtn-PWo5dz8U_5WlrXsQmiSNMeqY4-XHR7SMIJVaur09qM",
};
